/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteFence } from '../fn/fences/delete-fence';
import { DeleteFence$Params } from '../fn/fences/delete-fence';
import { Fence } from '../models/fence';
import { fences } from '../fn/fences/fences';
import { Fences$Params } from '../fn/fences/fences';
import { fencesbyrace } from '../fn/fences/fencesbyrace';
import { Fencesbyrace$Params } from '../fn/fences/fencesbyrace';

@Injectable({ providedIn: 'root' })
export class FencesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fencesbyrace()` */
  static readonly FencesbyracePath = '/races/{raceGuid}/fences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fencesbyrace()` instead.
   *
   * This method doesn't expect any request body.
   */
  fencesbyrace$Response(params: Fencesbyrace$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Fence>>> {
    const obs = fencesbyrace(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fencesbyrace$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fencesbyrace(params: Fencesbyrace$Params, context?: HttpContext): Observable<Array<Fence>> {
    const resp = this.fencesbyrace$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Fence>>): Array<Fence> => r.body)
    );
  }

  /** Path part for operation `fences()` */
  static readonly FencesPath = '/fences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fences()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fences$Response(params: Fences$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = fences(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fences$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fences(params: Fences$Params, context?: HttpContext): Observable<void> {
    const resp = this.fences$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteFence()` */
  static readonly DeleteFencePath = '/races/{raceGuid}/fences/{fenceGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFence()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFence$Response(params: DeleteFence$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteFence(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFence$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFence(params: DeleteFence$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteFence$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
